import { css } from '@emotion/react';

const stationFooterStyle = {
    container: css({
        color: '#000000',
        padding: '15px 25px 0',
        backgroundColor: '#ffffff',
        maxWidth: '600px',
        width: '100%',
        margin: '0 auto',
    }),
    title: css({
        margin: '0 0 15px 5px',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '19px',
        lineHeight: '23px',
        textTransform: 'capitalize',
    }),
    content: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    }),
    infoBlock: css({
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    }),
    infoBlockIcon: css({
        marginTop: '5px',
    }),
    infoBlockTitle: css({
        fontStyle: 'normal',
        fontSize: '12px',
        lineHeight: '15px',
        opacity: 0.5,
    }),
    infoBlockValue: css({
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '16px',
        whiteSpace: 'pre-line',
        textDecoration: 'none',
        color: '#000000',

        '&[href^="mailto:"]': {
            color: '#004FC6',
            textDecoration: 'underline',
        },
    }),
    link: css({
        textDecoration: 'none',
        color: '#000000',
    }),
};

export default stationFooterStyle;
